export default __webpack_public_path__ + "static/Clock-3ea022a7901d4e5720a2f84f46a8d5a8.svg";